/**
 * @generated SignedSource<<d5cc6c3024b2727de7e057a20d918361>>
 * @relayHash c806d2608abd9032f8dbaaa9c5e7d6c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 88f1dd504c735a71f7f33afa541197a22f94cc6d134effc568fe85144d94cd08

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DevaiIssueViewQuery$variables = {
  cloudId: string;
  isAiAgentSessionsPanelEnabled: boolean;
  isAssignToRovoDevActive: boolean;
  issueKey: string;
  issueViewRovoDevAgentsPanelEntitlementEnabled: boolean;
};
export type DevaiIssueViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueViewAgentPanel_rovodevQuery" | "RovodevAgentPanelWithEntitlementCheck">;
};
export type DevaiIssueViewQuery = {
  response: DevaiIssueViewQuery$data;
  variables: DevaiIssueViewQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryenableentitlementscheckrelayprovider": useOptimizedIssueViewQuery_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryissueviewagentspanelrelayprovider": includeBoysenberry_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryenableentitlementscheckrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryissueviewagentspanelrelayprovider: {
    readonly get: () => boolean;
  };
});

import useOptimizedIssueViewQuery_provider from '@jira/platform__graphql-relay-provider/src/boysenberry-enable-entitlements-check.relayprovider';
import includeBoysenberry_provider from '@jira/platform__graphql-relay-provider/src/boysenberry-issue-view-agents-panel.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAiAgentSessionsPanelEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAssignToRovoDevActive"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueViewRovoDevAgentsPanelEntitlementEnabled"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Literal",
  "name": "ownershipFilter",
  "value": "ALL"
},
v7 = [
  (v5/*: any*/)
],
v8 = {
  "concreteType": "DevAiEntitlementCheckResultResponse",
  "kind": "LinkedField",
  "name": "checks",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "entitlementType"
    },
    {
      "kind": "ScalarField",
      "name": "userHasProductAccess"
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "name": "isFeatureEnabled"
},
v10 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v11 = [
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  {
    "kind": "Variable",
    "name": "issueKey",
    "variableName": "issueKey"
  },
  (v6/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": "DESC"
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v13 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = [
  {
    "concreteType": "DevAiRovoDevSessionEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "DevAiRovoDevSession",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v14/*: any*/),
          (v13/*: any*/),
          {
            "kind": "ScalarField",
            "name": "sessionStatus"
          },
          {
            "kind": "ScalarField",
            "name": "updatedAt"
          },
          {
            "concreteType": "DevAiRovoDevRepository",
            "kind": "LinkedField",
            "name": "repository",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "url"
              },
              {
                "kind": "ScalarField",
                "name": "targetBranch"
              },
              {
                "kind": "ScalarField",
                "name": "branchUrl"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "promptAdf"
          },
          {
            "kind": "ScalarField",
            "name": "sessionTitle"
          },
          {
            "kind": "ScalarField",
            "name": "buildStatus"
          },
          {
            "kind": "ScalarField",
            "name": "prStatus"
          },
          {
            "kind": "ScalarField",
            "name": "prUrl"
          },
          (v12/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "name": "cursor"
      }
    ]
  },
  {
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "hasNextPage"
      },
      {
        "kind": "ScalarField",
        "name": "endCursor"
      }
    ]
  },
  (v10/*: any*/)
],
v16 = [
  "issueKey",
  "cloudId",
  "ownershipFilter"
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DevaiIssueViewQuery",
    "selections": [
      {
        "condition": "isAiAgentSessionsPanelEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v5/*: any*/),
              {
                "kind": "Variable",
                "name": "isAssignToRovoDevActive",
                "variableName": "isAssignToRovoDevActive"
              }
            ],
            "kind": "FragmentSpread",
            "name": "IssueViewAgentPanel_rovodevQuery"
          }
        ]
      },
      {
        "condition": "issueViewRovoDevAgentsPanelEntitlementEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v6/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "RovodevAgentPanelWithEntitlementCheck"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryenableentitlementscheckrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryissueviewagentspanelrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "DevaiIssueViewQuery",
    "selections": [
      {
        "condition": "isAiAgentSessionsPanelEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "condition": "isAssignToRovoDevActive",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v7/*: any*/),
                "concreteType": "DevAiRovoDevIssueViewResponse",
                "kind": "LinkedField",
                "name": "devai_rovodevIssueViewQuery",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/)
                ]
              }
            ]
          },
          (v10/*: any*/)
        ]
      },
      {
        "condition": "issueViewRovoDevAgentsPanelEntitlementEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "DevAiRovoDevIssueViewResponse",
            "kind": "LinkedField",
            "name": "devai_rovodevIssueViewQuery",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryenableentitlementscheckrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v11/*: any*/),
                    "concreteType": "DevAiRovoDevSessionConnection",
                    "kind": "LinkedField",
                    "name": "sessions",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "DevAiRovoDevSessionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v12/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryissueviewagentspanelrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "AuthenticationContext",
                "kind": "LinkedField",
                "name": "me",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ]
                  }
                ]
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryenableentitlementscheckrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v7/*: any*/),
                    "concreteType": "DevAiRovoDevIssueViewResponse",
                    "kind": "LinkedField",
                    "name": "devai_rovodevIssueViewQuery",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v11/*: any*/),
                        "concreteType": "DevAiRovoDevSessionConnection",
                        "kind": "LinkedField",
                        "name": "sessions",
                        "plural": false,
                        "selections": (v15/*: any*/)
                      },
                      {
                        "args": (v11/*: any*/),
                        "filters": (v16/*: any*/),
                        "handle": "connection",
                        "key": "BoysenberryCodePanel__sessions",
                        "kind": "LinkedHandle",
                        "name": "sessions"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryenableentitlementscheckrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "args": (v11/*: any*/),
                    "concreteType": "DevAiRovoDevSessionConnection",
                    "kind": "LinkedField",
                    "name": "devai_rovodevSessionsByIssueKey",
                    "plural": false,
                    "selections": (v15/*: any*/)
                  },
                  {
                    "args": (v11/*: any*/),
                    "filters": (v16/*: any*/),
                    "handle": "connection",
                    "key": "BoysenberryCodePanel__devai_rovodevSessionsByIssueKey",
                    "kind": "LinkedHandle",
                    "name": "devai_rovodevSessionsByIssueKey"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "88f1dd504c735a71f7f33afa541197a22f94cc6d134effc568fe85144d94cd08",
    "metadata": {},
    "name": "DevaiIssueViewQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryenableentitlementscheckrelayprovider": useOptimizedIssueViewQuery_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryissueviewagentspanelrelayprovider": includeBoysenberry_provider
    }
  }
};
})();

(node as any).hash = "97fd34c7e3714ca895e582d83c7110eb";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
